// rtk设置
export default {
    deviceServiceNumber: '设备服务号',
    currentStatus: '当前状态',
    validUntil: '有效期至',
    assigned: '已分配',
    unassigned: '未分配',
    inactivated: '未激活',
    inService: '服务中',
    expired: '已过期',
}